import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { isPlatformBrowser } from '@angular/common';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ToastContainerComponent } from './components/toast-container/toast-container.component';
import { CookieBannerComponent } from './components/cookie-banner/cookie-banner.component';


@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, TranslateModule, ToastContainerComponent, CookieBannerComponent],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent implements OnInit {
  title = 'Atlas';
  private previousBackgroundColor: string | null = null;
  private isRunningInBrowser = false;

  constructor(
    private translate: TranslateService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    this.isRunningInBrowser = isPlatformBrowser(this.platformId);

    if (this.isRunningInBrowser) {
      const savedLanguage = localStorage.getItem('language') || 'it';
      this.translate.setDefaultLang(savedLanguage);
      this.translate.use(savedLanguage);
    } else {
      this.translate.setDefaultLang('it');
      this.translate.use('it');
    }
  }

  ngOnInit(): void {
    if (this.isRunningInBrowser) {
      const savedLanguage = localStorage.getItem('language') || 'it';
      this.translate.setDefaultLang(savedLanguage);
      this.translate.use(savedLanguage);
    } else {
      this.translate.setDefaultLang('it');
      this.translate.use('it');
    }
  }

  changeBackgroundColor() {
    const mainElement = document.querySelector('body') as HTMLElement;
    const currentBackgroundColor = mainElement.style.backgroundColor;

    if (this.previousBackgroundColor === null) {
      this.previousBackgroundColor = currentBackgroundColor;
      mainElement.style.backgroundColor = '#131314';
    } else {
      mainElement.style.backgroundColor = this.previousBackgroundColor;
      this.previousBackgroundColor = currentBackgroundColor;
    }
  }

  changeLanguage(lang: string): void {
    this.translate.use(lang);

    if (this.isRunningInBrowser && this.isLocalStorageAvailable()) {
      localStorage.setItem('language', lang);
    }
  }

  private isLocalStorageAvailable(): boolean {
    try {
      const testKey = '__test__';
      localStorage.setItem(testKey, testKey);
      localStorage.removeItem(testKey);
      return true;
    } catch (e) {
      return false;
    }
  }
}
